import React, { FC } from 'react';
import './ButtonRow.less';
import clsx from 'clsx';

export default function ButtonRow({ children, className }: { children: FC | FC[]; className: string }) {
    return <div className={clsx('nui-button-row', className)}>{children}</div>;
}
